function TableNavigationItem({ page, pageNumber, goToPage }) {

  const handleClick = (e) => {
    e.preventDefault();
    goToPage(pageNumber);
  }
  
  return (
    <li key={pageNumber}>
      <a
        className={pageNumber === page ? 'active' : ''}
        onClick={handleClick}
        href="#">{pageNumber}</a>
    </li>
  )
}

export default TableNavigationItem